<script lang="ts">
	import HugeHeading from "@components/HugeHeading.svelte";
	import PartnerCard from "@components/PartnerCard.svelte";
	import Carousel from "@components/common/Carousel.svelte";
	import type { EmblaCarouselType } from "embla-carousel";
	import autoscroll from "embla-carousel-auto-scroll";
	import type { ClassValue } from "svelte/elements";
	import type { WebPartner } from "@core/schema/WebPartner.js";

	const { partners, class: customClass }: { partners: WebPartner[]; class?: ClassValue } = $props();
	let api = $state<EmblaCarouselType>();
</script>

<section class={[customClass, "full-width py-8 md:py-16 lg:py-20"]}>
	<HugeHeading level={2} text="stroke[[Bez koho by to nešlo?]]" class="text-center mb-1 sm:mb-4" />
	<div
		role="presentation"
		onmouseleave={(): void => {
			api?.plugins().autoScroll.play();
		}}
	>
		<Carousel
			bind:api
			items={partners}
			options={{ loop: true }}
			plugins={[autoscroll({ playOnInit: true, stopOnMouseEnter: true, startDelay: 0, direction: "backward" })]}
		>
			{#snippet item(partner)}
				<PartnerCard {partner} class="mx-1" />
			{/snippet}
		</Carousel>
	</div>
</section>
